import React from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Stop from 'material-ui/svg-icons/av/stop';
import PlayArrow from 'material-ui/svg-icons/av/play-arrow';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

const iconStyles = {
  color: '#fff',
};


function preventHijacking(event) {
event.stopPropagation();
event.preventDefault();
}

const ListenRecording = (props) => {
  if (!props.deviceConfig.supportsRecording || props.config.environment === 'android') {
    return <span />;
  }
  console.log('listen', props.text.texts[props.text.activeText]);
  const isActive = (props.isStopped() || props.isPlayingRecording)
                    && props.text.texts.length > 0
                    && props.text.texts[props.text.activeText].audioBuffer !== null;
  const label = props.isPlayingRecording
        ? <Stop />
        : <PlayArrow />;
  return (
    <span>
      <FloatingActionButton
        id="play"
        title="Listen to your recording"
        backgroundColor="#d52b1e"
        iconStyle={iconStyles}
        onClick={props.toggleRecordPlayback}
        className="pronounce-button play-recording"
        disabled={!isActive}
      >
        {label}
      </FloatingActionButton>
      <div className="listenBlock">
    Play your take
    {isActive &&    <IconMenu
                onClick={preventHijacking}
                iconButtonElement={<IconButton style={{padding: 0, width: 0, height: 0, marginTop: '-3px'}}><MoreVertIcon /></IconButton>}
                anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
                listStyle={{paddingTop: 0, paddingBottom: 0, overflow: 'hidden', width: 150}}
                children={<MenuItem primaryText="Download audio" onTouchTap={props.downloadAudio} /> }
            >

            </IconMenu>}
          </div>
    </span>
    );
};
export default ListenRecording;



// WEBPACK FOOTER //
// ./src/components/ListenRecording.js